import { createFileRoute } from "@tanstack/react-router";
import { AnalizaKorzysciRdaPage } from "@/features/contracts/analiza-korzysci-rda-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/rda/analiza-korzysci")({
	component: AnalizaKorzysciRdaPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.rda.analiza-korzysci",
			location.pathname,
		);
	},
});
